import { getNumberOfChanges, LinqsetChanges } from "../common/linqset-change-model";

const byKey = <T extends {_key:string}>(list:T[]) => new Set((list || []).map(i => i._key))

// changes that failed to save, with any made while they were saving on top. An item added in one and deleted in the
// other cancels out; a node changed in both keeps the later values
export const combineLinqsetChanges = (failed:LinqsetChanges, later:LinqsetChanges):LinqsetChanges => {
    if (!later || getNumberOfChanges(later) === 0) return {...failed, newModel: failed.newModel || later?.newModel}

    const addedLater = byKey(later.newNodes), deletedLater = byKey(later.deletedNodes)
    const addedEdgesLater = byKey(later.newEdges), deletedEdgesLater = byKey(later.deletedEdges)

    const nodeChanges = [...failed.nodeChanges]
    later.nodeChanges.forEach(c => {
        const i = nodeChanges.findIndex(e => e._key === c._key)
        if (i < 0) nodeChanges.push(c)
        else nodeChanges[i] = {...nodeChanges[i], ...c, properties: {...nodeChanges[i].properties, ...c.properties}}
    })

    return {
        newModel: failed.newModel || later.newModel,
        newNodes: failed.newNodes.filter(n => !deletedLater.has(n._key)).concat(later.newNodes.filter(n => !failed.newNodes.some(f => f._key === n._key))),
        deletedNodes: failed.deletedNodes.filter(n => !addedLater.has(n._key)).concat(later.deletedNodes.filter(n => !byKey(failed.newNodes).has(n._key))),
        nodeChanges: nodeChanges.filter(c => !deletedLater.has(c._key)),
        newEdges: failed.newEdges.filter(e => !deletedEdgesLater.has(e._key)).concat(later.newEdges.filter(e => !failed.newEdges.some(f => f._key === e._key))),
        deletedEdges: failed.deletedEdges.filter(e => !addedEdgesLater.has(e._key)).concat(later.deletedEdges.filter(e => !byKey(failed.newEdges).has(e._key))),
        edgeChanges: failed.edgeChanges.filter(e => !byKey(later.edgeChanges).has(e._key) && !deletedEdgesLater.has(e._key)).concat(later.edgeChanges),
    }
}
